/**
 * Autoplay API - 暴露给自动播放脚本的API
 * 提供游戏控制、状态获取等功能的封装
 */
/* eslint-disable */
var t = require('../lang').t;
var store = require('../../store').default;
var states = require('../../control/states').default;
var actions = require('../../actions').default;
var want = require('../../unit/').want;
var music = require('../../unit/music').music;
var delays = require('../../unit/const').delays;
var speeds = require('../../unit/const').speeds;

// 游戏结束回调存储
var gameOverCallbacks = [];
var isGameOverSubscribed = false;

/**
 * 获取当前游戏状态
 * @returns {Object} 游戏状态对象
 */
function getState() {
  var state = store.getState();

  // 确定游戏状态
  var gameStateStr = 'waiting';
  if (state.get('reset')) {
    gameStateStr = 'over';
  } else if (state.get('pause')) {
    gameStateStr = 'paused';
  } else if (state.get('cur') !== null) {
    gameStateStr = 'playing';
  }

  // 获取当前方块信息
  var cur = state.get('cur');
  var currentPiece = null;
  if (cur !== null) {
    var xy = cur.xy;
    // xy 是 Immutable List [row, col]，即 [y, x]
    var xyArray = xy && typeof xy.get === 'function' ? [xy.get(1), xy.get(0)] : (xy.x !== undefined ? [xy.x, xy.y] : [0, 0]);
    currentPiece = {
      type: cur.type,
      x: xyArray[0],  // x = col
      y: xyArray[1],  // y = row
      rotation: cur.rotateIndex,
      shape: cur.shape.toJS ? cur.shape.toJS() : cur.shape,
    };
  }

  // 获取矩阵
  var matrix = state.get('matrix');
  var matrixData = matrix && matrix.toJS ? matrix.toJS() : [];

  return {
    gameState: gameStateStr,
    score: state.get('points') || 0,
    highScore: state.get('max') || 0,
    level: state.get('speedRun') || 1,
    linesCleared: state.get('clearLines') || 0,
    currentPiece: currentPiece,
    nextPiece: state.get('next') || null,
    matrix: matrixData,
    speed: state.get('speedRun') || 1,
    isLocked: state.get('lock') || false,
    isPaused: state.get('pause') || false,
    isGameOver: state.get('reset') || false,
  };
}

/**
 * 移动方块
 * @param {string} direction - 'left', 'right', 'down'
 * @returns {Promise<Object>} 执行结果
 */
function move(direction) {
  return new Promise(function(resolve) {
    var state = store.getState();

    if (state.get('lock')) {
      resolve({ success: false, error: t('游戏处于锁定状态', 'Game is locked') });
      return;
    }

    var cur = state.get('cur');
    if (cur === null) {
      resolve({ success: false, error: t('没有活动方块', 'No active block') });
      return;
    }

    if (state.get('pause')) {
      states.pause(false);
    }

    var next;
    if (direction === 'left') {
      next = cur.left();
    } else if (direction === 'right') {
      next = cur.right();
    } else if (direction === 'down') {
      next = cur.fall();
    } else {
      resolve({ success: false, error: t('无效的移动方向: ', 'Invalid move direction: ') + direction });
      return;
    }

    var matrix = state.get('matrix');
    if (want(next, matrix)) {
      if (music.move) {
        music.move();
      }
      store.dispatch(actions.moveBlock(next));
      resolve({ success: true, direction: direction });
    } else {
      resolve({ success: false, error: t('无法移动，被阻挡', 'Cannot move, blocked') });
    }
  });
}

/**
 * 旋转方块
 * @returns {Promise<Object>} 执行结果
 */
function rotate() {
  return new Promise(function(resolve) {
    var state = store.getState();

    if (state.get('lock')) {
      resolve({ success: false, error: t('游戏处于锁定状态', 'Game is locked') });
      return;
    }

    var cur = state.get('cur');
    if (cur === null) {
      resolve({ success: false, error: t('没有活动方块', 'No active block') });
      return;
    }

    if (state.get('pause')) {
      states.pause(false);
    }

    var next = cur.rotate();
    var matrix = state.get('matrix');
    if (want(next, matrix)) {
      if (music.rotate) {
        music.rotate();
      }
      store.dispatch(actions.moveBlock(next));
      resolve({ success: true });
    } else {
      resolve({ success: false, error: t('空间不足，无法旋转', 'Not enough space to rotate') });
    }
  });
}

/**
 * 硬降
 * @returns {Promise<Object>} 执行结果
 */
function hardDrop() {
  return new Promise(function(resolve) {
    var state = store.getState();

    if (state.get('lock')) {
      resolve({ success: false, error: t('游戏处于锁定状态', 'Game is locked') });
      return;
    }

    var cur = state.get('cur');
    if (cur === null) {
      resolve({ success: false, error: t('没有活动方块', 'No active block') });
      return;
    }

    if (state.get('pause')) {
      states.pause(false);
    }

    if (music.fall) {
      music.fall();
    }

    var index = 0;
    var bottom = cur.fall(index);
    var matrix = state.get('matrix');

    while (want(bottom, matrix)) {
      bottom = cur.fall(index);
      index++;
    }

    var finalIndex = index - 2;
    if (finalIndex < 0) {
      finalIndex = 0;
    }
    var finalBottom = cur.fall(finalIndex);
    var shape = finalBottom.shape;
    var xy = finalBottom.xy;

    var newMatrix = matrix;
    var xyRow = xy && typeof xy.get === 'function' ? xy.get(0) : xy[0];
    var xyCol = xy && typeof xy.get === 'function' ? xy.get(1) : xy[1];

    for (var k1 = 0; k1 < shape.size; k1++) {
      for (var k2 = 0; k2 < shape.get(k1).size; k2++) {
        var n = shape.get(k1).get(k2);
        if (n && xyRow + k1 >= 0) {
          var line = newMatrix.get(xyRow + k1);
          line = line.set(xyCol + k2, 1);
          newMatrix = newMatrix.set(xyRow + k1, line);
        }
      }
    }

    store.dispatch(actions.moveBlock(finalBottom));
    store.dispatch(actions.drop(true));
    setTimeout(function() {
      store.dispatch(actions.drop(false));
    }, 100);

    states.nextAround(newMatrix);

    resolve({ success: true });
  });
}

/**
 * 开始游戏
 * @returns {Promise<Object>} 执行结果
 */
function start() {
  return new Promise(function(resolve) {
    var state = store.getState();

    if (state.get('cur') !== null && !state.get('reset')) {
      resolve({ success: false, error: t('游戏已在进行中', 'Game already in progress') });
      return;
    }

    states.start();
    resolve({ success: true, message: t('游戏已开始', 'Game started') });
  });
}

/**
 * 重新开始游戏
 * @returns {Promise<Object>} 执行结果
 */
function restart() {
  return new Promise(function(resolve) {
    var state = store.getState();

    if (state.get('cur') !== null) {
      states.overStart();
    }

    setTimeout(function() {
      states.overEnd();
      states.start();
    }, 150);

    resolve({ success: true, message: '游戏已重新开始' });
  });
}

/**
 * 暂停/继续游戏
 * @param {boolean} pause - true为暂停，false为继续
 * @returns {Promise<Object>} 执行结果
 */
function pause(pause) {
  return new Promise(function(resolve) {
    var state = store.getState();
    var cur = state.get('cur');

    if (cur === null) {
      resolve({ success: false, error: '没有活动游戏' });
      return;
    }

    var currentPause = state.get('pause');
    var newPause = pause !== undefined ? pause : !currentPause;
    states.pause(newPause);

    resolve({ success: true, paused: newPause });
  });
}

/**
 * 执行命令序列
 * @param {Array} commands - 命令数组
 * @returns {Promise<Object>} 执行结果
 */
function executeSequence(commands) {
  return new Promise(function(resolve) {
    var results = [];

    function executeNext(index) {
      if (index >= commands.length) {
        resolve({
          success: true,
          executedCount: results.length,
          results: results,
        });
        return;
      }

      var cmd = commands[index];
      var promise;

      if (cmd.action === 'move') {
        promise = move(cmd.direction);
      } else if (cmd.action === 'rotate') {
        promise = rotate();
      } else if (cmd.action === 'hardDrop') {
        promise = hardDrop();
      } else if (cmd.action === 'pause') {
        promise = pause(cmd.pause);
      } else {
        promise = Promise.resolve({ success: false, error: '未知命令: ' + cmd.action });
      }

      promise.then(function(result) {
        results.push(result);
        if (result.error === '游戏锁定' || result.error === '没有活动方块') {
          resolve({
            success: false,
            executedCount: results.length,
            results: results,
            error: result.error,
          });
        } else {
          // 硬降后等待游戏解锁
          if (cmd.action === 'hardDrop') {
            setTimeout(function() {
              executeNext(index + 1);
            }, 150);
          } else {
            setTimeout(function() {
              executeNext(index + 1);
            }, 30);
          }
        }
      });
    }

    executeNext(0);
  });
}

/**
 * 显示思考消息
 * @param {string} message - 消息内容
 */
function say(message) {
  if (!message || typeof message !== 'string') {
    return;
  }

  if (message.length > 100) {
    message = message.substring(0, 97) + '...';
  }

  // 触发全局消息回调
  if (window.__tetrisMessageCallback) {
    window.__tetrisMessageCallback(message);
  }

  // 添加到消息队列
  if (!window.__tetrisMessages) {
    window.__tetrisMessages = [];
  }
  window.__tetrisMessages.push({
    text: message,
    time: Date.now(),
  });

  // 保持队列大小
  if (window.__tetrisMessages.length > 5) {
    window.__tetrisMessages.shift();
  }
}

/**
 * 等待函数
 * @param {number} ms - 毫秒数
 * @returns {Promise<void>}
 */
function sleep(ms) {
  return new Promise(function(resolve) {
    setTimeout(resolve, ms);
  });
}

/**
 * 注册游戏结束回调
 * @param {Function} callback - 回调函数
 */
function onGameOver(callback) {
  if (typeof callback !== 'function') {
    return;
  }

  gameOverCallbacks.push(callback);

  // 订阅状态变化
  if (!isGameOverSubscribed) {
    isGameOverSubscribed = true;
    store.subscribe(function() {
      var state = store.getState();
      if (state.get('reset') && window.__tetrisAutoplayActive) {
        var result = {
          score: state.get('points') || 0,
          linesCleared: state.get('clearLines') || 0,
          level: state.get('speedRun') || 1,
          timestamp: Date.now(),
        };

        // 保存结果到全局
        window.__tetrisAutoplayResult = result;
        window.__tetrisAutoplayActive = false;

        // 调用所有回调
        gameOverCallbacks.forEach(function(cb) {
          try {
            cb(result);
          } catch (e) {
            console.error('[Autoplay] 回调错误:', e);
          }
        });

        // 如果有等待中的wait，解析它
        if (window.__tetrisAutoplayWaitResolve) {
          window.__tetrisAutoplayWaitResolve({
            success: true,
            message: '游戏结束',
            result: result,
          });
          window.__tetrisAutoplayWaitResolve = null;
        }
      }
    });
  }
}

/**
 * 日志输出
 * @param {string} message - 日志消息
 */
function log(message) {
  console.log('[Autoplay]', message);
}

// 构建API对象
var gameAPI = {
  getState: getState,
  move: move,
  rotate: rotate,
  hardDrop: hardDrop,
  start: start,
  restart: restart,
  pause: pause,
  executeSequence: executeSequence,
  say: say,
  sleep: sleep,
  onGameOver: onGameOver,
  log: log,
};

module.exports = gameAPI;



// WEBPACK FOOTER //
// ./src/webmcp/tools/autoplayAPI.js